"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.definition = void 0;
var tslib_1 = require("tslib");
var joi_1 = tslib_1.__importDefault(require("joi"));
var endpoint_definition_details_generator_1 = require("../../../helpers/endpoint.definition.details.generator");
var api_response_def_1 = require("../../../shared/api.response.def");
var types_def_1 = require("../../../shared/types.def");
var query = joi_1.default.object({
    tags: joi_1.default.object(Object.assign.apply(Object, tslib_1.__spreadArray([{}], [1, 2, 3].map(function (x) {
        var _a;
        return (_a = {},
            _a["JOB_ID".concat(x)] = joi_1.default.array().items({ uuid: joi_1.default.string() }),
            _a);
    }), false))),
    type: joi_1.default.string(),
    time: types_def_1.dateDefault.optional(),
    timezone: joi_1.default.string().default(Intl.DateTimeFormat().resolvedOptions().timeZone),
    units: joi_1.default.string().default('meters'),
});
var response = joi_1.default.object({
    exportId: joi_1.default.string(),
    notification: joi_1.default.array(),
    url: joi_1.default.string(),
});
exports.definition = (0, endpoint_definition_details_generator_1.makeDefinitionFor)('/action/export', {
    requestBody: {
        schema: query,
        description: '**Types:** `KML`, `EXCEL`, `JSON`, `IMAGE_ZIP`. **Units:** `meters`, `feet`. **JOB_IDx**: The actual ID of the job you are selecting from',
        required: true,
    },
    method: 'post',
    summary: 'Export collection information',
    description: 'Used for exporting collections in different formats',
    tags: ['Export'],
}, [
    {
        code: 200,
        description: api_response_def_1.success,
        schema: response,
    },
    (0, api_response_def_1.generateValidationError)(),
]);
//# sourceMappingURL=export.get.schema.js.map